import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    position: "relative",
    minHeight: "calc(100vh - 300px)",
    paddingBottom: "40px",
  },
  title: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: 16,
    lineHeight: "24px",
    color: "#465869",
    height: "auto !important",
  },
  uploadBadge: {
    width: "100%",
    padding: "8px 16px",
    height: 35,
    borderRadius: 8,
  },
  progressBar: {
    background: "#32D583",
  },
  uploadBadgeText: {
    fontFamily: "Manrope",
    fontWeight: 700,
    fontSize: 12,
    lineHeight: "24px",
    color: "#FFFFFF",
  },
  button: {
    minWidth: "15%",
  },
  documentsField: {
    marginTop: "16px",
    marginBottom: "20px",
  },
  loading: {
    transform: "scale(1, 1) !important",
  },
}));

export default styles;
